import { IIconBase } from '..'

const certifiedIcon = ({
  color = '#198754',
  height = 24,
  width = 25,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/verify'>
        <g id='verify'>
          <path
            id='Vector'
            d='M8.88 12L11.29 14.42L16.12 9.57996'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M11.25 2.44995C11.94 1.85995 13.07 1.85995 13.77 2.44995L15.35 3.80995C15.65 4.06995 16.21 4.27995 16.61 4.27995H18.31C19.37 4.27995 20.24 5.14995 20.24 6.20995V7.90995C20.24 8.29995 20.45 8.86995 20.71 9.16995L22.07 10.7499C22.66 11.4399 22.66 12.5699 22.07 13.2699L20.71 14.8499C20.45 15.1499 20.24 15.7099 20.24 16.1099V17.8099C20.24 18.8699 19.37 19.7399 18.31 19.7399H16.61C16.22 19.7399 15.65 19.9499 15.35 20.2099L13.77 21.5699C13.08 22.1599 11.95 22.1599 11.25 21.5699L9.67 20.2099C9.37 19.9499 8.81 19.7399 8.41 19.7399H6.68C5.62 19.7399 4.75 18.8699 4.75 17.8099V16.0999C4.75 15.7099 4.54 15.1499 4.29 14.8499L2.94 13.2599C2.36 12.5699 2.36 11.4499 2.94 10.7599L4.29 9.16995C4.54 8.86995 4.75 8.30995 4.75 7.91995V6.19995C4.75 5.13995 5.62 4.26995 6.68 4.26995H8.41C8.8 4.26995 9.37 4.05995 9.67 3.79995L11.25 2.44995Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default certifiedIcon
